import React from "react";
import Framework from "@beardeddevops/react.framework";
import {Types} from "components";
import Card from "@material-ui/core/Card";

export default class EngineerStats extends Framework.Components.Object {
	constructor(props) {
		super(props, Types.Engineer_Stats._name);
	}

	render() {
		let {properties} = this.model
		let object = this.state
		let {loading} = this.state

		return (
			<Card style={{padding: 15}}>

				<Framework.Elements.LoadingSpinner isLoading={loading}/>

				<div className={'row'} style={{paddingBottom: 10}}>

					<div className={'col-4'} style={{paddingLeft: 5, paddingRight: 5}}>
						<Framework.Elements.TextField
							label={"Today's WO Avg"}
							value={Math.round(parseFloat(object.total_stats_today ?? 0) * 100) / 100}
							error={object.total_stats_today_error}
							property={properties.total_stats_today}
							update={this.handleTextFieldPropertyUpdate}
							disabled={true}
						/>
					</div>

					<div className={'col-4'} style={{paddingLeft: 5, paddingRight: 5}}>
						<Framework.Elements.TextField
							label={"Trailing 7day Avg"}
							value={Math.round(parseFloat(object.total_stats_7day ?? 0) * 100) / 100}
							error={object.total_stats_7day_error}
							property={properties.total_stats_7day}
							update={this.handleTextFieldPropertyUpdate}
							disabled={true}
						/>
					</div>

					<div className={'col-4'} style={{paddingLeft: 5, paddingRight: 5}}>
						<Framework.Elements.TextField
							label={"Trailing 30d Avgl"}
							value={Math.round(parseFloat(object.total_stats_30day ?? 0) * 100) / 100}
							error={object.total_stats_30day_error}
							property={properties.total_stats_30day}
							update={this.handleTextFieldPropertyUpdate}
							disabled={true}
						/>
					</div>

				</div>
				<div className={'row'}>

					<div className={'col-4'} style={{paddingLeft: 5, paddingRight: 5}}>
						<Framework.Elements.TextField
							label={"AV Sales"}
							value={Math.round(parseFloat(object.anti_virus_30day ?? 0) * 100) / 100}
							error={object.anti_virus_30day_error}
							property={properties.anti_virus_30day}
							update={this.handleTextFieldPropertyUpdate}
							disabled={true}
						/>
					</div>

					<div className={'col-4'} style={{paddingLeft: 5, paddingRight: 5}}>
						<Framework.Elements.TextField
							label={"Carbonite Sales"}
							value={Math.round(parseFloat(object.carbonite_30day ?? 0) * 100) / 100}
							error={object.carbonite_30day_error}
							property={properties.carbonite_30day}
							update={this.handleTextFieldPropertyUpdate}
							disabled={true}
						/>
					</div>
{/*
					<div className={'col-4'}>
						<Framework.Elements.TextField
							label={"Last Week Reviews"}
							value={Math.round(parseFloat(object.reviews_7d) * 100) / 100}
							error={object.reviews_7d_error}
							property={properties.reviews_7d}
							update={this.handleTextFieldPropertyUpdate}
							disabled={true}
						/>
					</div>*/}

				</div>
			</Card>
		)
	}
}
